module.exports = __webpack_public_path__ + "img/Eric.8e9cbf9.JPG";